import { Card, SxProps, Theme, useMediaQuery, useTheme } from "@mui/material";
import React from "react";

interface Props {
  children?: React.ReactNode
  sx?: SxProps<Theme>
}

export const HankoSecondaryCard = (props: Props) => {
  const {sx} = props
  const theme = useTheme()
  const matchesSmDown = useMediaQuery(theme.breakpoints.down('sm'))
  const width = matchesSmDown ? 'calc(100vw - 48px)' : '336px'

  return <Card sx={{
    borderRadius: '16px',
    backgroundColor: "#16191E",
    border: "1px solid #262B35",
    width: width,
    height: '200px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    p: 4,
    boxShadow: '1px 4px 8px 0 rgba(0, 0, 0, 0.50)',
    ...sx,
  }} elevation={0}>
    {props.children}
  </Card>
}